import Link from "next/link"

export default function NotFound() {
  return (
    <div className='ps-page--404'>
      <div className='container'>
        <div className='ps-section__content'>
          <figure>
            <h3>Não encontramos essa página</h3>
            <p>Não encontramos o que você estava procurando.</p>
            <p>
              Volte para a <Link href='/'>Homepage</Link>
            </p>
          </figure>
        </div>
      </div>
    </div>
  )
}
